<template>
  <button @click="loadOptionsAndUpdate" class="btn btn-sm btn-primary">
    <font-awesome-icon icon="road"/>&nbsp;{{ $t('route') }}
    <b-modal v-model="showForm" :title="$t('route') + ': ' + formModel.number" @ok="save" no-close-on-backdrop size="lg"
             no-enforce-focus>
      <div class="row">
        <div class="col">
          <h4 v-if="formModel.inbound">{{ $t('inboundSetting') }}</h4>
          <template v-if="formModel.inbound">
            <form-checkbox :model="formModel" attribute="recordInbound" :chk-label="$t('recordInbound')"></form-checkbox>
            <form-checkbox :model="formModel" attribute="inboundFollow" :chk-label="$t('inboundFollow')"></form-checkbox>
            <form-select v-if="formModel.inboundFollow" :model="formModel" :errors="formErrors" :options="inboundFollowBys" attribute="inboundFollowBy"
                         :label="$t('inboundFollowBy')" :full-width="true">
            </form-select>
            <form-input v-if="formModel.inboundFollow" :model="formModel" attribute="inboundFollowTimeout" :errors="formErrors" :label="$t('inboundFollowTimeout')"></form-input>
            <target-select :client-id="phoneNumber.client._id" :model="formModel" attribute="inboundTarget" :errors="formErrors" :label="$t('routeInboundTo')"></target-select>
          </template>
          <h4 v-if="formModel.outbound">{{ $t('outboundSetting') }}</h4>
          <template v-if="formModel.outbound">
            <form-checkbox :model="formModel" attribute="recordOutbound" :chk-label="$t('recordOutbound')"></form-checkbox>
            <form-select :model="formModel" attribute="outboundFromType" :errors="formErrors" :options="outboundFromTypes" :label="$t('outboundFromType')" :full-width="true"></form-select>
            <form-checkbox-group
                v-if="formModel.outboundFromType ==='group' && outboundFromGroups.length > 0"
                :model="formModel"
                attribute="outboundFromGroups"
                errors="formErrors"
                :label="$t('outboundFromGroups')"
                :options="outboundFromGroups">
            </form-checkbox-group>
            <form-input v-if="formModel.outboundFromType ==='custom'" :model="formModel" attribute="outboundFromPattern" :errors="formErrors" :label="$t('pattern')"></form-input>
            <form-select :model="formModel" attribute="outboundToType" :errors="formErrors" :options="outboundToTypes" :label="$t('outboundToType')" :full-width="true"></form-select>
            <form-input v-if="formModel.outboundToType ==='custom'" :model="formModel" attribute="outboundToPattern" :errors="formErrors" :label="$t('pattern')"></form-input>
            <form-checkbox-group
                v-if="formModel.outboundToType ==='network'"
                :model="formModel"
                attribute="outboundToNetworks"
                errors="formErrors"
                :label="$t('outboundToNetworks')"
                :options="outboundToNetworks">
            </form-checkbox-group>
            <form-select :model="formModel" :errors="formErrors" attribute="backupNumber" :options="backupNumberList"
                         :label="$t('backupNumber')" :full-width="true"></form-select>
          </template>
          <span v-else class="badge badge-danger">{{ $t('outboundDisabled') }}</span>
          <hr>
          <form-input :model="formModel" attribute="priority" :errors="formErrors" :label="$t('priority')"></form-input>
        </div>
      </div>
      <template v-slot:modal-footer>
        <b-button variant="secondary" class="float-right" @click="showForm = false">{{ $t('close') }}
        </b-button>
      </template>
    </b-modal>
  </button>
</template>
<script>
import CRUD from "../../mixins/CRUD";
import TargetSelect from "../../components/ClientTargetSelect";

export default {
  props: ['phoneNumber'],
  components: {TargetSelect},
  mixins: [CRUD],
  data() {
    return {
      showForm: false,
      service: '/phone-number',
      outboundFromTypes: [
        {value: 'all', text: this.$t('all')},
        {value: 'group', text: this.$t('group')},
        {value: 'custom', text: this.$t('custom')},
      ],
      inboundFollowBys: [
        {value: null, text: this.$t('chooseInboundFollowBy')},
        {value: 'contact', text: this.$t('inboundFollowByContact')},
        {value: 'lastcall', text: this.$t('inboundFollowByLastCall')},
      ],
      outboundFromGroups: [],
      outboundToNetworks: [],
      outboundToTypes: [
        {value: 'all', text: this.$t('all')},
        {value: 'network', text: this.$t('network')},
        {value: 'custom', text: this.$t('custom')},
      ],
      backupNumberList: [{value: null, text: this.$t('chooseBackupNumber')}],

    }
  },
  methods: {
    loadOptionsAndUpdate() {
      this.outboundFromGroups = [];
      this.$bgService.get('/client-user-group', {
        params: {
          page: 1,
          pageSize: 1000,
          status: 0,
          client: this.phoneNumber.client._id
        }
      }).then(response => {
        response.data.docs.forEach(item => {
          this.outboundFromGroups.push({value: item._id, text: item.ext + ' (' + item.name + ')'});
        });
      });
      this.outboundToNetworks = [];
      this.$bgService.get('/phone-network', {
        params: {
          page: 1,
          pageSize: 1000,
          status: 0
        }
      }).then(response => {
        response.data.docs.forEach(item => {
          if (item.numberPrefixes.length > 0) {
            this.outboundToNetworks.push({value: item._id, text: item.name});
          }
        });
      });
      this.$bgService.get('/phone-number', {
        params: {
          page: 1,
          pageSize: 1000,
          client: this.phoneNumber.client._id
        }
      }).then(response => {
        response.data.docs.forEach(item => {
          if (item._id !== this.phoneNumber._id && item.outbound) {
            this.backupNumberList.push({value: item._id, text: item.number});
          }
        });
      });
      this.update(this.phoneNumber._id);
    }
  },
  i18n: {
    messages: {
      en: {
        route: "Phone route",
        inboundSetting: "Inbound setting",
        outboundSetting: "Outbound setting",
        recordOutbound: "Record outbound",
        outboundFromType: "Outbound from",
        outboundToType: "Outbound to",
        backupNumber: "Backup number",
        chooseBackupNumber: "Choose backup number",
        custom: "Custom",
        pattern: "Pattern",
        priority: "Priority",
        outboundToNetworks: "Outbound to networks",
        recordInbound: "Record inbound",
        inboundFollow: "Inbound follow",
        inboundFollowBy: "Inbound follow by",
        chooseInboundFollowBy: "Choose inbound follow by",
        inboundFollowTimeout: "Inbound follow timeout",
        inboundFollowByContact: "Inbound follow by contact",
        inboundFollowByLastCall: "Inbound follow by last call",
        outboundFromGroups: "Choose group",
        routeInboundTo: "Inbound target to",
        close: "Close",
      },
      vi: {
        route: "Định tuyến gọi",
        inboundSetting: "Cấu hình gọi vào",
        outboundSetting: "Cấu hình gọi ra",
        recordOutbound: "Ghi âm cuộc gọi đi",
        outboundFromType: "Gọi ra từ",
        outboundToType: "Gọi ra đến",
        backupNumber: "Số dự phòng",
        chooseBackupNumber: "Chọn số dự phòng",
        custom: "Tuỳ biến",
        pattern: "Pattern",
        priority: "Độ ưu tiên",
        outboundToNetworks: "Gọi ra đến mạng",
        recordInbound: "Ghi âm cuộc gọi đến",
        inboundFollow: "Ưu tiên định tuyến tới nhân viên quen",
        inboundFollowBy: "Ưu tiên định tuyến theo",
        chooseInboundFollowBy: "Chọn ưu tiên định tuyến theo",
        inboundFollowTimeout: "Thời gian đổ chuông tới nhân viên quen (giây)",
        inboundFollowByContact: "Nhân viên phụ trách",
        inboundFollowByLastCall: "Nhân viên gọi gần nhất",
        outboundFromGroups: "Chọn nhóm",
        routeInboundTo: "Đổ chuông đến (nếu không chọn, chuông sẽ đổ tới tất cả người dùng)",
        close: "Đóng",
      }
    }
  }
}
</script>